import { computed, Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class Modal {
  private readonly _showModal: WritableSignal<boolean> = signal(false);
  readonly show = this._showModal.asReadonly();

  constructor () {}

  toggle = (visible: boolean) => {
    this._showModal.set(visible);
  }
}
